import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListMediatipsComponent } from './list-mediatips/list-mediatips.component';

const routes: Routes = [
  {
       path: '', component: ListMediatipsComponent
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: [],
})

export class MediatipsRoutingModule { }
